import { gql } from 'graphql-tag';

export const getAllPaymentMethodsQuery = gql`
query {
	getAllPaymentMethods {
		results {
			id
			paymentName
			isEnable
			paymentType
		}
		status
		errorMessage
	}
}`;

export const updatePaymentMutation = gql`
mutation updatePayment ($id: Int, $status: Boolean){
    updatePayment(id: $id, status: $status){
        status
        errorMessage
      }
  }`;

export const makePayment = gql`mutation makePayment(
    $bookingId: Int!
    $paymentType: Int!
    $paymentCurrency:String
  ) {
makePayment (
    bookingId: $bookingId
    paymentType: $paymentType
    paymentCurrency:$paymentCurrency
) {
    status
    errorMessage
    result{
        id
        name
        userId
        partnerId
        userLocation
        partnerLocation
        bookingId
        categoryId
        totalFare
        userTotalFare
        partnerTotalFare
        paymentType
        specialServiceTotalFare
        requireAdditionalAction
        paymentIntentSecret
        redirectURL
    }
}
}`

export const confirmPayment = gql`mutation confirmPayment(
    $bookingId: Int!
    $paymentIntentId: String!,
) {
    confirmPayment(
        bookingId: $bookingId
        paymentIntentId: $paymentIntentId,
    ) {
        status
        errorMessage
    }
}`

export const updateTipsMutation = `mutation updateTips(
  $bookingId: Int
  $amount: Float
  $paymentType: Int
  $currency:String
  $isUpdateTip:Boolean
) {
updateTips (
  bookingId: $bookingId
  amount: $amount
  paymentType: $paymentType
  currency:$currency
  isUpdateTip:$isUpdateTip
) {
  status
  errorMessage
}
}`

export const updatePaypalCurrency = gql`mutation updatePaypalCurrency(
  $currency: String!
 ) {
updatePaypalCurrency(currency: $currency) {
status
errorMessage
}
}`